export const ADMIN = 'Administrator';
export const SCHEDULER = 'ProjectScheduler';



// WEBPACK FOOTER //
// ./src/constants/roles.js